import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'aof-input-text',
  standalone: true,
  imports: [TohumUiModule],
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent implements OnInit {

  @Input() inputWidth = 9;
  @Input() labelText: string;
  @Input() placeholder: string;
  @Input() helperText: string;
  @Input() inputName: string;
  @Input() inputId = '';
  @Input() inputSize: string | 'lg' | 'sm' = null;
  @Input() readonly = false;
  @Input() horizontal = false;
  @Input() model: string;
  @Input() wasValidated = true;
  @Input() errors: string[];
  @Input() isPassword = false;
  @Input() textTransform: 'none' | 'uppercase' | 'lowercase' = 'none';
  @Input() maxlength: number;

  @Output() modelChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onChange(newModel: string) {

    if(newModel.length > this.maxlength) {
     newModel = this.model;
    }
    
    let newModelTransform = newModel;
    if (this.textTransform ==='none') {
      newModelTransform = newModel;
    }
    else if (this.textTransform ==='uppercase') {
      newModelTransform = newModel.toLocaleUpperCase('tr-TR');
    }
    else if (this.textTransform ==='lowercase') {
      newModelTransform = newModel.toLocaleLowerCase('tr-TR');
    }

    this.model = newModelTransform;
    this.modelChange.emit(newModelTransform);
  }

}